export const MODAL_MODES = {
    CREATE: "create",
    UPDATE: "update",
};
export const CUSTOMER_SERVICE_TYPES = [8, 9];

export const RESET_PASSWORD_OPTIONS = {
    SEND_EMAIL: "SEND_EMAIL",
    GENERATE_PASSWORD: "GENERATE_PASSWORD",
};
